/**
 * The values of the ExpenseCategory, BillingCycle and SupplierAmountEstimateSource enums in the
 * order the selects offer them. Their labels are translated as "expense.category.<value>",
 * "expense.billingCycle.<value>" and "expense.amountEstimateSource.<value>".
 */
export const EXPENSE_CATEGORIES = [
    'INFRASTRUCTURE',
    'SERVICES_AND_LICENSES',
    'HARDWARE_AND_EQUIPMENT',
    'VEHICLES',
    'TRAVEL',
    'INSURANCE',
    'CONSULTING_AND_ADMINISTRATION',
    'MEMBERSHIPS_AND_DONATIONS',
    'OTHER',
] as const;

export const BILLING_CYCLES = [
    'MONTHLY_IN_ARREARS',
    'MONTHLY_IN_ADVANCE',
    'QUARTERLY_IN_ADVANCE',
    'YEARLY_IN_ADVANCE',
    'ONE_TIME',
] as const;

export const AMOUNT_ESTIMATE_SOURCES = [
    'HETZNER',
] as const;

export type ExpenseCategory = typeof EXPENSE_CATEGORIES[number];
export type BillingCycle = typeof BILLING_CYCLES[number];
export type AmountEstimateSource = typeof AMOUNT_ESTIMATE_SOURCES[number];
